import { Maatregel, VsmStatus } from "@/entities/vsm";
import { VsmDto } from "@/shared/types";

export type Vsm = {
    id: number;
    spoorwebId?: string;
    toelichting: string | undefined;
    vsmStatus: VsmStatus;
    maatregelen: Maatregel[];
};

export const Vsm = {
    fromDto: (dto: VsmDto): Vsm => ({
        id: dto.id,
        spoorwebId: dto.spoorwebId,
        toelichting: dto.toelichting,
        vsmStatus: dto.vsmStatus,
        maatregelen: dto.maatregelen.map((maatregel) => Maatregel.fromDto(maatregel)),
    }),
};
